import { createApp } from 'vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import App from './App.vue'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { createPinia } from 'pinia'
import * as Sentry from '@sentry/vue'

import { OryPlugin } from '@/plugins/ory'

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(router)
app.use(i18n)
app.use(OryPlugin)
app.use(pinia)

app.use(createVuestic({ config: vuesticGlobalConfig }))

if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
      vueRouter: router,
    }),
  )
}
Sentry.init({
  environment: import.meta.env.VITE_SENTRY_ENV,
  app,
  dsn: 'https://712d53a8b09c726d2475fc5b4db37385@o1071387.ingest.us.sentry.io/4508024018239488',
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
    Sentry.browserProfilingIntegration(),
  ],
  profilesSampleRate: 0.25,
  tracesSampleRate: 0.25,
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 0.25,
})

app.mount('#app')
